import { prefixLanguage } from '@utils/urls'

export const API_BASE_URL = prefixLanguage('/api/v1/')
export const prefixAPI = (url, model = '') => API_BASE_URL + model + url
